import { ProductDetailPageResult } from "../ProductDetailPageResult";

export interface CarouselPlacement {
  showCAVCarousel: boolean;
  showRecAiCarousel: boolean;
  showYMANCarousel: boolean;
  showOPFTLCarouselAboveDescription: boolean;
  showOPFTLCarouselBelowDescription: boolean;
}

export default (activeTemplate: ProductDetailPageResult): CarouselPlacement => {
  const {
    showEverlivingProductPage,
    youMayAlsoNeedCarouselItems,
    customersAlsoViewedCarouselItems,
    otherProductsFromThisLine,
    isRecAiEligible,
    isDemotedPart,
    isVirtualPart,
  } = activeTemplate;

  const showYMANCarousel =
    !showEverlivingProductPage && youMayAlsoNeedCarouselItems?.length > 0;

  // customers also viewed carousel shows when more than 1 item in the collection, otherwise it
  // goes in a side tile.
  const showCAVCarousel =
    !!customersAlsoViewedCarouselItems &&
    customersAlsoViewedCarouselItems.length > 1;

  const showOPFTLCarouselAboveDescription =
    otherProductsFromThisLine?.length > 0 &&
    !showYMANCarousel &&
    !showCAVCarousel;

  let aboveDescriptionCarouselsToShow = 0;
  if (showYMANCarousel) aboveDescriptionCarouselsToShow += 1;
  if (showCAVCarousel) aboveDescriptionCarouselsToShow += 1;
  if (showOPFTLCarouselAboveDescription) aboveDescriptionCarouselsToShow += 1;

  const showRecAiCarousel =
    !showEverlivingProductPage &&
    isRecAiEligible &&
    aboveDescriptionCarouselsToShow < 2 &&
    !(isDemotedPart || isVirtualPart);

  const showOPFTLCarouselBelowDescription =
    otherProductsFromThisLine?.length > 0 && !showOPFTLCarouselAboveDescription;

  return {
    showCAVCarousel,
    showRecAiCarousel,
    showYMANCarousel,
    showOPFTLCarouselAboveDescription,
    showOPFTLCarouselBelowDescription,
  };
};
